$(document).ready(function(){


  $('.main-review-slider').slick({
    slidesToShow: 2,  // Desktop
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    rows: 2,
    autoplaySpeed: 3000,
    dots: false, 
    arrows: false, 
    centerMode: true,
    centerPadding: '200px',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.home-prd-slider').slick({
    slidesToShow: 3,  // Desktop
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,  
    arrows: false, 
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600, // Mobile
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.home-prd-slider2').slick({
    slidesToShow: 3,  // Desktop
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    // rows: 2,
    autoplaySpeed: 3000,
    dots: true,          // Dots enabled
    arrows: false,        // Arrows enabled
    responsive: [
      {
        breakpoint: 1024, // Tablet
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600, // Mobile
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.home-blog-slider').slick({
    slidesToShow: 2,  // Desktop
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '40px', 
    responsive: [
      {
        breakpoint: 1024, // Tablet
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 600, // Mobile
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });


  $('.home-testimonial-slider').slick({
    slidesToShow: 1,  // Desktop
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,          // Dots enabled
    arrows: false,        // Arrows enabled
    responsive: [
      {
        breakpoint: 1024, // Tablet
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 600, // Mobile
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('.fc-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.fc-thumbnail-slider',
    prevArrow: '<button class="slick-prev"><i class="fa fa-long-arrow-left"></i></button>',
    nextArrow: '<button class="slick-next"><i class="fa fa-long-arrow-right"></i></button>'
  });

  $('.fc-thumbnail-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.fc-main-slider',
    dots: false,
    focusOnSelect: true,
    arrows: false,
    infinite: true,  // Ye line add kari hai taake thumbnails repeat hote rahen
    centerMode: true,
  }); 


  // Har page load pe active class remove karna
  $('.fc-menu nav ul li').removeClass('active');

  // Current URL lena
  var currentUrl = window.location.pathname;

  // Jo bhi link current page se match kare usko active class dena
  $('.fc-menu nav ul li a').each(function() {
    if ($(this).attr('href') === currentUrl) {
      $(this).parent().addClass('active');
    }
  });


});



function increment() {
  var quantityInput = document.getElementById("quantity");
  var currentValue = parseInt(quantityInput.value);
  quantityInput.value = currentValue + 1;
}

function decrement() {
  var quantityInput = document.getElementById("quantity");
  var currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
  }
}

document.addEventListener("DOMContentLoaded", function() {
    function equalizeParagraphHeights() {
        let paragraphs = document.querySelectorAll(".fc-prd-right-area .fc-prd-content .in-left p");
        
        // Check if paragraphs exist
        if (paragraphs.length === 0) {
            console.warn("No paragraphs found.");
            return;
        }

        let maxHeight = 0;

        // Set height to auto first to get the natural height
        paragraphs.forEach(p => p.style.height = "auto");

        // Find the max height among all paragraphs
        paragraphs.forEach(p => {
            maxHeight = Math.max(maxHeight, p.offsetHeight);
        });

        // Set the height of all paragraphs to the max height
        paragraphs.forEach(p => p.style.height = maxHeight + "px");
    }

    // Run the function when the page reloads
    equalizeParagraphHeights();
});


document.addEventListener("DOMContentLoaded", function() {
    function equalizeParagraphHeights2() {
        let paragraphs = document.querySelectorAll(".fc-prd-right-area .fc-prd-content .in-left h4");
        
        // Check if paragraphs exist
        if (paragraphs.length === 0) {
            console.warn("No paragraphs found.");
            return;
        }

        let maxHeight = 0;

        // Set height to auto first to get the natural height
        paragraphs.forEach(p => p.style.height = "auto");

        // Find the max height among all paragraphs
        paragraphs.forEach(p => {
            maxHeight = Math.max(maxHeight, p.offsetHeight);
        });

        // Set the height of all paragraphs to the max height
        paragraphs.forEach(p => p.style.height = maxHeight + "px");
    }

    // Run the function when the page reloads
    equalizeParagraphHeights2();
});

